<ng-container *transloco="let t; read: 'event-request-config-table-editor'">
  <p-toast position="bottom-center"></p-toast>
  <app-data-table
    [actionsTemplate]="actionsTemplate"
    [cols]="cols"
    [loading]="loading"
    [refreshClicked]="getDataWrapper"
    [rowReorderEnabled]="true"
    [selectedCols]="cols"
    [tableRows]="tableRows"
    [title]="t('title')"
    [translationScope]="'event-request-config-table-editor'"
    (rowReordered)="onRowsReordered($event)"
  >
    <ng-container appDataTableColumnDef="edit">
      <th *appDataTableHeader>{{ t('colEdit') }}</th>
      <td *appDataTableCell="let rowData">
        <button
          class="p-button-rounded p-button-primary p-button-text"
          pButton
          type="button"
          [attr.aria-label]="t('editEventTypeButtonLabel', { displayName: rowData.data.eventType.getDisplayName() })"
          (click)="editEventType(rowData)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-template #actionsTemplate>
      <p-button
        icon="pi pi-plus"
        styleClass="p-button-outlined"
        [ariaLabel]="t('createEventTypeButtonLabel')"
        [label]="t('createEventTypeButtonLabel')"
        (onClick)="createEventType()"
      ></p-button>
    </ng-template>
  </app-data-table>
  <app-progress-spinner *ngIf="loading"></app-progress-spinner>
</ng-container>
